import { createListenerMiddleware } from '@reduxjs/toolkit';
import { matchPath } from 'react-router-dom';

import type { RootState } from 'reduxStore';
import { endChat } from 'api/resources/chat';
import type { WebChatState } from './webChatSlice';

type EnvKey = Exclude<keyof WebChatState, 'draftArtifactVersions'>;

const CLIENT_ENVS: EnvKey[] = ['draft', 'sandbox', 'pre-release', 'live'];

function getProjectRouteFromUrl(): {
  accountId: string;
  projectId: string;
} | null {
  const match = matchPath('/:accountId/:projectId/*', window.location.pathname);
  if (!match?.params.accountId || !match?.params.projectId) return null;
  return {
    accountId: match.params.accountId,
    projectId: match.params.projectId,
  };
}

export const webChatListenerMiddleware = createListenerMiddleware<RootState>();

webChatListenerMiddleware.startListening({
  predicate: (_action, currentState, previousState) => {
    return CLIENT_ENVS.some(env => {
      const prev = previousState.webChat[env].conversationId;
      const curr = currentState.webChat[env].conversationId;
      return prev != null && curr == null;
    });
  },
  effect: async (_action, listenerApi) => {
    const previousState = listenerApi.getOriginalState() as RootState;
    const currentState = listenerApi.getState() as RootState;
    const route = getProjectRouteFromUrl();
    if (!route) return;

    for (const env of CLIENT_ENVS) {
      const prevConvId = previousState.webChat[env].conversationId;
      const currConvId = currentState.webChat[env].conversationId;
      const prevStatus = previousState.webChat[env].status;

      if (
        prevConvId &&
        !currConvId &&
        prevStatus !== 'ended' &&
        prevStatus !== 'idle'
      ) {
        endChat({
          accountId: route.accountId,
          projectId: route.projectId,
          conversationId: prevConvId,
          clientEnv: env,
          languageCode: previousState.webChat[env].asrLanguageCode || '',
          channelType: previousState.webChat[env].channel,
        }).catch(() => {});
      }
    }
  },
});
